// extracted by mini-css-extract-plugin
module.exports = {"link":"_84ff5fbbc9--link--fKr7E","accent":"_84ff5fbbc9--accent--WLJs3","primary":"_84ff5fbbc9--primary--iQH7h","light":"_84ff5fbbc9--light--Xxqcf"};